import AtcFlightSegmentAlternatives from './flight-segment-alternatives-component';
import AtcFlightSegmentAlternativesService from './flight-segment-alternatives-service';

import './flight-segment-alternatives.scss';

const MODULE_NAME = 'app.atc.flight.segment.alternatives';
const module = angular.module(MODULE_NAME, [])
    .directive(AtcFlightSegmentAlternatives.DIRECTIVE_NAME, AtcFlightSegmentAlternatives)
    .service('atcFlightSegmentAlternativesService', AtcFlightSegmentAlternativesService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-segment-alternatives/flight-segment-alternatives-module.js